import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeDialogContext } from '@base/react';
import { AppContext } from '../../components/shared/context';

export const CompanyLayout = ({ children, isEmpresaSelected }) => {
  const { empresa } = React.useContext(AppContext);
  const { showNotification } = React.useContext(BaSeDialogContext);
  const { navigateTo, isExactRoute } = Sebrae.useRouter();

  if (!empresa && !isExactRoute('/') && isEmpresaSelected) {
    showNotification({
      color: 'attention',
      message: 'Atenção',
      supportMessage: 'Selecione uma empresa',
    });
    navigateTo('/');
    return <></>;
  }
  return children;
};
